export default "https://cdn-static.gokick.com/assets/5afcce0631de89212d84c9203934006157ee1462/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";